import React from "react";
import { ArrowLeft, Building2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";

/**
 * Shown when a partner / company_operator user has entered a portfolio workspace.
 * Renders a persistent dark banner with the company name + a button to exit back to the
 * partner / operator dashboard. Detection is via localStorage["partner_origin_token"]
 * which is set by PartnerDashboard / OperatorDashboard on enterWorkspace().
 */
export default function ActingWorkspaceBanner() {
    const { api } = useAuth();
    const origin = typeof window !== "undefined" ? localStorage.getItem("partner_origin_token") : null;
    const wsName = typeof window !== "undefined" ? localStorage.getItem("partner_acting_workspace_name") : null;

    if (!origin) return null;

    const exit = async () => {
        // Decode origin token to find the source role (partner vs operator)
        let homeRoute = "/partner";
        try {
            const payload = JSON.parse(atob(origin.split(".")[1]));
            if (payload.role === "company_operator") homeRoute = "/operator";
        } catch { /* ignore */ }
        // Best-effort: tell backend so the audit log captures the exit
        try {
            await api.post(homeRoute === "/operator" ? "/v2/operator/companies/exit" : "/v2/partner/workspaces/exit");
        } catch { /* ignore — we're going to swap the token anyway */ }
        localStorage.setItem("token", origin);
        localStorage.removeItem("partner_origin_token");
        localStorage.removeItem("partner_acting_workspace_name");
        window.location.href = homeRoute;
    };

    return (
        <div className="bg-amber-500/10 border-b border-amber-500/30 px-4 py-2.5 flex items-center justify-between"
            data-testid="acting-workspace-banner">
            <div className="flex items-center gap-3 text-xs">
                <Building2 className="w-4 h-4 text-amber-300" />
                <span className="text-amber-300 font-mono uppercase tracking-wider">Inside workspace:</span>
                <span className="text-white">{wsName || "Portfolio company"}</span>
            </div>
            <button onClick={exit}
                className="text-xs text-amber-300 hover:text-white inline-flex items-center gap-2 font-mono uppercase tracking-wider"
                data-testid="exit-workspace-btn">
                <ArrowLeft className="w-3.5 h-3.5" /> Back to portfolio
            </button>
        </div>
    );
}
